export const actionTypes = {
  GET_LIST_EXERCISE: 'GET_LIST_EXERCISE',
  GET_LIST_EXERCISE_SUCCESS: 'GET_LIST_EXERCISE_SUCCESS',
  GET_LIST_EXERCISE_FAIL: 'GET_LIST_EXERCISE_FAIL',

  GET_DETAIL_EXERCISE: 'GET_DETAIL_EXERCISE',
  GET_DETAIL_EXERCISE_SUCCESS: 'GET_DETAIL_EXERCISE_SUCCESS',
  GET_DETAIL_EXERCISE_FAIL: 'GET_DETAIL_EXERCISE_FAIL',

  CREATE_EXERCISE: 'CREATE_EXERCISE',
  CREATE_EXERCISE_SUCCESS: 'CREATE_EXERCISE_SUCCESS',
  CREATE_EXERCISE_FAIL: 'CREATE_EXERCISE_FAIL',

  UPDATE_EXERCISE_SUCCESS: 'UPDATE_EXERCISE_SUCCESS',

  DELETE_EXERCISE: 'DELETE_EXERCISE',
  DELETE_EXERCISE_SUCCESS: 'DELETE_EXERCISE_SUCCESS',
  DELETE_EXERCISE_FAIL: 'DELETE_EXERCISE_FAIL',

  DELETE_IMAGE_EXERCISE: 'DELETE_IMAGE_EXERCISE',
  DELETE_IMAGE_EXERCISE_SUCCESS: 'DELETE_IMAGE_EXERCISE_SUCCESS',
  DELETE_IMAGE_EXERCISE_FAIL: 'DELETE_IMAGE_EXERCISE_FAIL',
  
  GET_BRIKLO_LIST_EXERCISE: 'GET_BRIKLO_LIST_EXERCISE',
  GET_BRIKLO_LIST_EXERCISE_SUCCESS: 'GET_BRIKLO_LIST_EXERCISE_SUCCESS',
  GET_BRIKLO_LIST_EXERCISE_FAIL: 'GET_BRIKLO_LIST_EXERCISE_FAIL',

  CLEAR_LIST_EXERCISE: 'CLEAR_LIST_EXERCISE'
};

export const actions = {
  getBrikloListExercise: () => ({
    type: actionTypes.GET_BRIKLO_LIST_EXERCISE,
  }),
  getBrikloListExerciseSuccess: (data: any) => ({
    type: actionTypes.GET_BRIKLO_LIST_EXERCISE_SUCCESS,
    payload: data,
  }),
  getBrikloListExerciseFail: (err: any) => ({
    type: actionTypes.GET_BRIKLO_LIST_EXERCISE_FAIL,
    payload: err,
  }),

  getListExercise: () => ({
    type: actionTypes.GET_LIST_EXERCISE,
  }),
  getListExerciseSuccess: (data: any) => ({
    type: actionTypes.GET_LIST_EXERCISE_SUCCESS,
    payload: data,
  }),
  getListExerciseFail: (err: any) => ({
    type: actionTypes.GET_LIST_EXERCISE_FAIL,
    payload: err,
  }),

  getDetailExercise: () => ({
    type: actionTypes.GET_DETAIL_EXERCISE,
  }),
  getDetailExerciseSuccess: (data: any) => ({
    type: actionTypes.GET_DETAIL_EXERCISE_SUCCESS,
    payload: data,
  }),
  getDetailExerciseFail: (err: any) => ({
    type: actionTypes.GET_DETAIL_EXERCISE_FAIL,
    payload: err,
  }),

  createExercise: () => ({
    type: actionTypes.CREATE_EXERCISE,
  }),
  createExerciseSuccess: (data: any) => ({
    type: actionTypes.CREATE_EXERCISE_SUCCESS,
    payload: data,
  }),
  createExerciseFail: (err: any) => ({
    type: actionTypes.CREATE_EXERCISE_FAIL,
    payload: err,
  }),

  deleteExercise: () => ({
    type: actionTypes.DELETE_EXERCISE,
  }),
  deleteExerciseSuccess: (data: any) => ({
    type: actionTypes.DELETE_EXERCISE_SUCCESS,
    payload: data,
  }),
  deleteExerciseFail: (err: any) => ({
    type: actionTypes.DELETE_EXERCISE_FAIL,
    payload: err,
  }), 

  deleteImageExercise: () => ({
    type: actionTypes.DELETE_IMAGE_EXERCISE,
  }),
  deleteImageExerciseSuccess: (data: any) => ({
    type: actionTypes.DELETE_IMAGE_EXERCISE_SUCCESS,
    payload: data,
  }),
  deleteImageExerciseFail: (err: any) => ({
    type: actionTypes.DELETE_IMAGE_EXERCISE_FAIL,
    payload: err,
  }),

  updateExerciseSuccess: (data: any) => ({
    type: actionTypes.UPDATE_EXERCISE_SUCCESS,
    payload: data
  }),

  clearListExercise: () => ({
    type: actionTypes.CLEAR_LIST_EXERCISE
  })
};
